// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"163f4b30","977":"5f841330"}[chunkId] + ".chunk.js";
};